"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelSkillFilterMap = exports.modelSkillSortMap = exports.aiModelFilterMap = exports.AIModelCredentialType = exports.AIModelType = exports.aiModelSortMap = void 0;
exports.aiModelSortMap = {
    name: "proc.name",
    type: "aim.type",
    registry: "aim.registry",
    processId: "aim.process_id",
    createdAt: "aim.created_at",
    updatedAt: "aim.updated_at",
};
var AIModelType;
(function (AIModelType) {
    AIModelType[AIModelType["Endpoint"] = 1] = "Endpoint";
    AIModelType[AIModelType["Model"] = 2] = "Model";
})(AIModelType || (exports.AIModelType = AIModelType = {}));
var AIModelCredentialType;
(function (AIModelCredentialType) {
    AIModelCredentialType["UserToken"] = "user_token";
    AIModelCredentialType["ServiceAccount"] = "service_account";
})(AIModelCredentialType || (exports.AIModelCredentialType = AIModelCredentialType = {}));
exports.aiModelFilterMap = {
    name: "proc.name",
    type: "aim.type",
    registry: "aim.registry",
    processId: "aim.process_id",
};
exports.modelSkillSortMap = {
    name: "proc.name",
    ownerUsername: "u.username",
    createdAt: "ms.created_at",
    updatedAt: "ms.updated_at",
};
exports.modelSkillFilterMap = {
    name: "proc.name",
    ownerUsername: "u.username",
};
